import React from 'react';
import ReturnFlow from './components/ReturnFlow';

const PosReturnsView = () => (
  <div className="container py-4">
    <h1 className="h3 fw-bold mb-1">Retours POS</h1>
    <p className="text-muted">Vue séparée pour le flux des retours POS.</p>
    <ReturnFlow />
  </div>
);

export default PosReturnsView;
